<script setup>
import { useVirtualList } from '@vueuse/core'
import { isEmpty } from 'lodash'
import { toRef } from 'vue'

import { HOMEPAGE_SIDEBAR_LIST_ITEM_GAP, HOMEPAGE_SIDEBAR_LIST_ITEM_HEIGHT } from '@/utils/homepage'

defineOptions({
  name: 'HomepageSidebarFilterList'
})

const props = defineProps({
  items: {
    type: Array,
    required: true
  },

  loading: {
    type: Boolean
  }
})

const { list, containerProps, wrapperProps } = useVirtualList(toRef(props, 'items'), {
  itemHeight: HOMEPAGE_SIDEBAR_LIST_ITEM_HEIGHT + HOMEPAGE_SIDEBAR_LIST_ITEM_GAP
})
</script>

<template>
  <div class="hsfl-Nav" v-bind="containerProps">
    <slot v-if="loading" name="loading" />

    <div v-else class="hsfl-List" v-bind="wrapperProps">
      <template v-if="!isEmpty(list)">
        <template v-for="item in list" :key="item.index">
          <slot :index="item.index" :item="item.data" name="item" />
        </template>
      </template>

      <slot v-else name="no-results" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '~@/assets/styles/homepage-mixins';

.hsfl-Nav {
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  padding-inline: var(--ob-hps-mx);
}

.hsfl-List {
  @include homepage-sidebar-list;
}
</style>
